// extracted by mini-css-extract-plugin
export default {"starterScreen":"el","starterImage":"fl","already":"gl","btnContainer":"hl","starterImageMobile":"il","starterTextContainWrapper":"jl","controlX":"kl","attrWrapper":"ll","logoWrapper":"ml","starterTextContain":"nl","starterHeader":"ol","starterBtn":"pl","starterSecondaryBtn":"ql","starterBanner":"rl","logoWrapperMob":"sl","mobileBtnContainer":"tl"};
    if(module.hot) {
      // 1711717530262
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  